import { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { ISingleAddressChangeApplication } from 'src/Types/module/applications/applications';
import MultipleAndSingleImgValidateWithPreview from 'src/common/FileValidation/MultipleAndSingleImgValidateWithPreview';
import { url } from 'src/Helpers/utils/Constant';
import Toaster from 'src/Toaster/Toaster';
import { IResponse } from 'src/basic-rest/types';
import { HttpClient } from 'src/Helpers/http/http';
import { useParams } from 'react-router-dom';
import { fetcherGet } from 'src/Utils/fetcher';
import AddressSelect from '../../subModules/memberList/singleMember/AddressSelect/AddressSelect';
type IProps = {
  application: ISingleAddressChangeApplication;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setApplication: React.Dispatch<
    React.SetStateAction<ISingleAddressChangeApplication>
  >;
};

const UpdateAddressChangeApp = ({
  application,
  setShowModal,
  setApplication,
}: IProps) => {
  const Toast = Toaster();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors, touchedFields },
    watch,
    getValues,
    reset,
  } = useForm<any>({
    defaultValues: {},
  });

  const isStatusReject = watch('address_change_application_status');
  useEffect(() => {
    reset({
      ...application,
    });
  }, [application]);
  const [loading, setLoading] = useState(false);
  const onSubmit = async (value: any) => {
    const formData = new FormData();

    const touchedValues = Object?.keys(touchedFields)?.reduce(
      (acc, key) => {
        acc[key] = getValues(key);
        return acc;
      },
      {} as Record<string, any>
    );
    if (Object?.keys(touchedValues)?.length) {
      Object?.keys(touchedValues)?.forEach((key) => {
        if (
          touchedValues[key] instanceof FileList ||
          Array.isArray(touchedValues[key])
        ) {
          const file = touchedValues[key][0];
          if (file) {
            formData.append(key, file);
          }
        } else {
          formData.append(key, touchedValues[key]);
        }
      });

      try {
        const res: IResponse = await HttpClient.patch(
          `${url}/api/member/address-change-application/${id}`,
          formData
        );

        if (res.success) {
          Toaster().fire({
            icon: 'success',
            title: res.message,
          });
          const data = await fetcherGet(
            `/member/address-change-application/${id}`
          );
          if (data?.success) {
            setApplication(data?.data);
          }
          setShowModal(false);
          reset({});
        }
      } catch (err: any) {
        Toaster().fire({
          icon: 'error',
          title: err?.response?.data.message,
        });
      }
    } else {
      Toast.fire({
        icon: 'error',
        title: `Change field first`,
      });
    }
  };

  return (
    <>
      <Box component='form' onSubmit={handleSubmit(onSubmit)} p={0}>
        <Grid container spacing={2} mb={2}>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Email'
              required
              id='outlined-required'
              type='email'
              {...register('address_change_application_email')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Phone number'
              id='outlined-required'
              type='number'
              {...register('address_change_application_phone')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Cellphone'
              id='outlined-required'
              type='number'
              {...register('address_change_application_cellphone')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Address '
              id='outlined-required'
              type='text'
              {...register('address_change_application_addressline')}
            />
          </Grid>

          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Postal code'
              required
              id='outlined-required'
              type='text'
              {...register('address_change_application_postal_code')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Police station'
              required
              id='outlined-required'
              type='text'
              {...register('address_change_application_police_station')}
            />
          </Grid>

          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Civil aviation file ( max size 5mb )'
              fieldName={`address_change_application_civil_aviation`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.address_change_application_civil_aviation,
              ]}
            />
          </Grid>

          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Trade license file ( max size 5mb )'
              fieldName={`address_change_application_trade_license`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[
                application?.address_change_application_trade_license,
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Forwarding letter ( max size 5mb )'
              fieldName={`address_change_application_form`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[application?.address_change_application_form]}
            />
          </Grid>
          {/* <ApplicationAddressSelect /> */}
          <AddressSelect
            registerFieldName='address_change_application_area_id'
            register={register}
            ownerInformation={{
              district_id: application.district_id,
              thana_id: application.thana_id,
              division_id: application.division_id,
              area_id: application.area_id,
            }}
          />
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id='demo-simple-select-label'>
                Select Status
              </InputLabel>
              <Select
                {...register('address_change_application_status')}
                labelId='demo-simple-select-label'
                label='Ownership status'
                defaultValue={application?.address_change_application_status}
              >
                <MenuItem value='pending'>Pending</MenuItem>
                <MenuItem value='approved'>Approved</MenuItem>
                <MenuItem value='rejected'>Rejected</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {(isStatusReject === 'rejected' ||
            (application?.address_change_application_reject_reason &&
              application.address_change_application_status ===
                'rejected')) && (
            <Grid item xs={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  placeholder='Write reason....'
                  id='outlined-basic'
                  label='Note'
                  variant='outlined'
                  {...register('address_change_application_reject_reason')}
                  multiline
                  type='text'
                  rows={3}
                  InputLabelProps={{ shrink: true }}
                />
              </FormControl>
            </Grid>
          )}
        </Grid>

        <Box mt={5}>
          {!loading ? (
            <Button
              type='submit'
              fullWidth
              variant='contained'
              disableElevation
            >
              Submit
            </Button>
          ) : (
            <LoadingButton
              loading
              loadingIndicator='Loading...'
              variant='contained'
              fullWidth
              disabled
            >
              <span>Loading...</span>
            </LoadingButton>
          )}
        </Box>
      </Box>
    </>
  );
};

export default UpdateAddressChangeApp;
